<script setup>
import { ref, computed, onMounted } from "vue";
import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useDataCollectionStore } from "@/stores/dataCollection";
import { useIntegrationsStore } from "@/stores/integrations";
import useValidation from "@/utils/helpers/validations";

const emit = defineEmits(["refresh"]);
const uiStore = useUiStore();
const dataCollectionStore = useDataCollectionStore();
const integrationsStore = useIntegrationsStore();
import { useToast } from "vue-toastification";

const toast = useToast();
const getModalInfo = computed(() => uiStore.modalData);
const getModalAction = computed(() => uiStore.modalAction);
const { checkUrlValidation } = useValidation();

const isFileUploaded = ref(false);
const company_id = useCompanyStore().companyId;
let isValidFile = ref(false);
let isSubmitted = ref(false);
let name = ref(null);
// let id = ref(null);
let fileName = ref(null);
let appFile = ref(null);
let fileError = ref(false);
let routeName = ref("");
const apkFile = ref(null);
let uploadPercentage = ref(0);
let validTypesFiles = ref([]);
let validExtensions = ref("");
let dataCollectionsOptions = ref([]);
let integrationOptions = ref([]);
let integration = ref(null);
let enableDataCollection = ref(false);
let source = ref("upload_file");
let url = ref(null);
let isValidUrl = ref(true);
let isLoadingIntegrations = ref(true);
import axios from "axios";

const uploadFile = async (e) => {
  fileError.value = false;
  let selectedFile = e.target.files[0];
  uploadPercentage.value = 0;
  let reader = new FileReader();
  reader.readAsDataURL(selectedFile);
  reader.onload = () => {
    //    //     fileError.value = true;
    //     return
    //   }else
    if (selectedFile && validTypesFiles.value.includes(selectedFile.type)) {
      fileName.value = selectedFile.name;
      apkFile.value = selectedFile;
      isFileUploaded.value = true;
    } else {
      fileError.value = true;
      return;
    }
  };
  reader.onerror = (evt) => {
    console.error(evt);
  };
};

const changeSourceVal = () => {
  isFileUploaded.value = false;
  isValidFile.value = null;
  fileName.value = null;
  fileError.value = false;
  isValidUrl.value = true;
  url.value = null;
};

const resetUploadedFileData = () => {
  isFileUploaded.value = false;
  isValidFile.value = null;
  fileName.value = null;
  appFile.value.value = null;
  fileError.value = false;
};

const resetStoreData = () => {
  uiStore.setModalState(false);
  uiStore.setModalData({});
  uiStore.setModalAction(null);
};

const validUrl = () => {
  isValidUrl.value = true;
  if (url.value.length > 0) {
    isValidUrl.value = checkUrlValidation(url.value);
    //    return isValidUrl.value;
  }
};

const onSubmit = () => {
  isSubmitted.value = true;

  let formData = new FormData();
  formData.append("name", name.value);

  formData.append("company_id", company_id);
  // formData.append("data_collection_id", data_collection.value.id);
  if (source.value == "upload_file") {
    formData.append("file", apkFile.value);
  } else if (source.value == "url") {
    formData.append("url", url.value);
  } else if (source.value == "integration") {
    formData.append("integration_id", integration.value.id);
  }
  axios
    .post(`${process.env.VUE_APP_BASE_URL}/api/${routeName.value}`, formData, {
      headers: {
        Accept: "application/json",
        "Content-type":
          source.value == "url" ? "application/json" : "multipart/form-data",
      },
      withCredentials: true,
      onUploadProgress: function (progressEvent) {
        uploadPercentage.value = parseInt(
          Math.round((progressEvent.loaded / progressEvent.total) * 100),
        );
      }.bind(this),
    })
    .then((res) => {
      toast.success(res.data.message);
      isSubmitted.value = false;
      resetStoreData();
      emit("refresh");
    })
    .catch((e) => {
      toast.error(e.response.data.message);
      isSubmitted.value = false;
    });
};

const fetchDataCollections = () => {
  dataCollectionStore
    .fetchDataCollectionsSimple(company_id)
    .then((res) => {
      dataCollectionsOptions.value = res.data;
    })
    .catch(() => {
    });
};

const fetchIntegrations = () => {
  integrationsStore
    .fetchIntegrations(company_id)
    .then(() => {
      //      integrationOptions.value = res.data;
      isLoadingIntegrations.value = false;
    })
    .catch(() => {
    });
};

onMounted(async () => {
  if (
    getModalInfo.value &&
    (getModalAction.value == "upload_file_data_mapping" ||
      getModalAction.value == "upload_json_file_data_mapping")
  ) {
    if (getModalInfo.value.enableDataCollection) {
      enableDataCollection.value = true;
    }

    if (getModalInfo.value.type == "json") {
      validTypesFiles.value = [
        "application/json",
        "application/jsonlines",
        "application/x-ndjson",
      ];
      validExtensions.value = "json";
      routeName.value = "upload-and-process-mapping";
    } else if (getModalInfo.value.type == "pdf") {
      validTypesFiles.value = ["application/pdf", "text/csv"];
      validExtensions.value = "pdf-csv";
      routeName.value = "file-upload";
    }
    await fetchDataCollections();
    await fetchIntegrations();
  }
});
</script>

<template>
  <DModal v-if="getModalAction === 'upload_file_data_mapping' || getModalAction === 'upload_json_file_data_mapping'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]"
    :dialog_classes="[]"
  >
    <template #title> Add Data Source </template>
    <template #body>
      <DInput :value="name" @input="name = $event.target.value" label="Name" width="100%" />

      <!-- <div class="relative mb-3">
        <span
          v-if="data_collection"
          class="multiselect-title-span"
          :class="{ 'disabled-div': !enableDataCollection }"
          >Data Collection</span
        >
        <VMultiselect
          v-model="data_collection"
          :options="dataCollectionsOptions"
          :disabled="!dataCollectionsOptions.length || !enableDataCollection"
          :loading="!dataCollectionsOptions.length"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          placeholder="Data Collection"
          trackBy="id"
          label="name"
        />
      </div> -->

      <div
        v-if="validExtensions == 'pdf-csv'"
        class="w-full flex unique-radio-inputs p-0 mb-3"
      >
        <div class="w-1/3 radioTwo p-0">
          <input
            @change="changeSourceVal()"
            class="form-check-input"
            type="radio"
            name="source"
            id="uploadFileOption"
            value="upload_file"
            v-model="source"
          />
          <label class="form-check-label" for="uploadFileOption"
            >Upload File</label
          >
        </div>

        <div class="w-1/3 radioOne p-0">
          <input
            @change="changeSourceVal()"
            class="form-check-input"
            type="radio"
            name="source"
            id="urlOption"
            value="url"
            v-model="source"
          />
          <label class="form-check-label" for="urlOption">URL</label>
        </div>

        <div class="w-1/3 radioOne p-0">
          <input
            @change="changeSourceVal()"
            class="form-check-input"
            type="radio"
            name="source"
            id="integrationOption"
            value="integration"
            v-model="source"
          />
          <label class="form-check-label" for="integrationOption"
            >Integration</label
          >
        </div>
      </div>

      <div v-if="source == 'upload_file'">
        <div
          class="container"
          :class="{
            'disabled-div': fileName && appFile,
            'is-invalid': fileError,
          }"
          @click="$refs.appFile.click()"
        >
          <div class="icon">
            <input
              ref="appFile"
              class="hidden"
              type="file"
              @change="uploadFile"
              :disabled="fileName && appFile"
              :accept="
                validExtensions == 'pdf-csv' ? '.pdf, .csv' : '.json, .jsonl'
              "
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="25"
              viewBox="0 0 22 25"
              fill="none"
            >
              <path
                fill="#787878"
                d="M11 0C5.22112 0 0.5 4.69532 0.5 10.5C0.5 15.0921 3.44102 18.9877 7.54298 20.4066V17.027C5.19527 15.7888 3.59582 13.312 3.59582 10.4742C3.59582 6.39807 6.92373 3.07006 11 3.07006C15.0761 3.07006 18.4041 6.39797 18.4041 10.4742C18.4041 13.3379 16.7788 15.8403 14.3796 17.0528V20.4067C18.5075 18.9877 21.5 15.0664 21.5 10.4743C21.5004 4.69541 16.7793 9.21307e-05 11.0005 9.21307e-05L11 0Z"
              />
              <path
                fill="#787878"
                d="M15.6981 11.8135C16.2914 11.2202 16.2914 10.2398 15.6981 9.62058L12.1121 6.03459C11.8026 5.72507 11.4155 5.57031 11.0286 5.57031C10.6416 5.57031 10.2289 5.72508 9.94504 6.03459L6.35905 9.62058C5.76573 10.2139 5.76573 11.1943 6.35905 11.8135C6.95237 12.4069 7.93276 12.4069 8.55201 11.8135L9.48076 10.8848V22.9585C9.48076 23.8098 10.1774 24.5065 11.0288 24.5065C11.8801 24.5065 12.5768 23.8099 12.5768 22.9585V10.8332L13.5571 11.8136C14.0985 12.4069 15.0788 12.4069 15.6981 11.8135Z"
              />
            </svg>
            <div class="add-files-text ml-16">Add Source File</div>
          </div>
        </div>

        <div
          v-if="fileName && appFile && !fileError"
          class="container success-container"
        >
          <div
            class="flex items-center justify-between"
            style="width: 416px !important"
          >
            <div class="flex padding-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="17"
                viewBox="0 0 18 17"
                fill="none"
                style="width: 17px; height: 17px; flex-shrink: 0"
              >
                <circle opacity="0.94" cx="9" cy="8.5" r="8.5" fill="#34C38F" />
                <path
                  fill="white"
                  d="M13.4765 5.6447C13.377 5.56806 13.263 5.51125 13.1411 5.4775C13.0192 5.44375 12.8917 5.43373 12.766 5.44801C12.6403 5.46229 12.5188 5.5006 12.4084 5.56074C12.298 5.62087 12.201 5.70167 12.1228 5.7985L8.17196 10.6829L5.86373 8.94634C5.67861 8.80689 5.44452 8.74467 5.21296 8.77336C4.98139 8.80205 4.77132 8.91932 4.62895 9.09935C4.48659 9.27938 4.42359 9.50744 4.45382 9.73335C4.48405 9.95926 4.60504 10.1645 4.79015 10.304L7.88422 12.6315C7.97952 12.7032 8.08888 12.7549 8.20548 12.7835C8.32207 12.8122 8.44337 12.817 8.56181 12.7978C8.68777 12.7838 8.80956 12.7456 8.9202 12.6855C9.03084 12.6254 9.12814 12.5445 9.20654 12.4476L13.6391 6.96608C13.7971 6.77033 13.8687 6.52115 13.8382 6.2733C13.8077 6.02544 13.6776 5.79919 13.4764 5.64427"
                />
              </svg>
              <div class="filename-text ml-16">{{ fileName }}</div>
            </div>
            <div class="padding-0">
              <button
                :disabled="isSubmitted"
                @click="resetUploadedFileData"
                class="remove-file-button"
              >
                Remove
              </button>
            </div>
          </div>
        </div>

        <!-- <span class="hint-input" :class="{'hint-input-error' : fileError }"><b>Note:</b> Uploaded file size should be 150MB or less.</span>   -->
        <span
          v-if="validExtensions == 'pdf-csv'"
          class="hint-input"
          :class="{ 'hint-input-error': fileError }"
          ><b>Note:</b> Only PDF and CSV files are supported as data
          sources.</span
        >
        <span
          v-if="validExtensions == 'json'"
          class="hint-input"
          :class="{ 'hint-input-error': fileError }"
          ><b>Note:</b> Only JSON files are supported as data sources.</span
        >
        <div v-if="isSubmitted" class="mt-20 w-full bg-gray-200 rounded-full h-4">
          <div class="bg-blue-500 h-4 rounded-full transition-all flex items-center justify-center"
               :style="{ width: uploadPercentage + '%' }">
            <span class="text-xs text-white px-2">{{ uploadPercentage }}%</span>
          </div>
        </div>
      </div>

      <div v-else-if="source == 'url'">
        <DInput :value="url" @input="(e) => { url = e.target.value; validUrl(); }" label="URL" width="100%" :class="{ 'is-invalid': !isValidUrl }" />
        <div v-if="!isValidUrl" class="invalid-feedback">Invalid URL.</div>
      </div>

      <div v-else-if="source == 'integration'">
        <div class="relative mb-3">
          <span
            v-if="integration"
            class="multiselect-title-span"
            :class="{ 'disabled-div': !enableDataCollection }"
            >Integration</span
          >
          <VMultiselect
            v-model="integration"
            :options="integrationOptions"
            :disabled="isLoadingIntegrations"
            :loading="isLoadingIntegrations"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Integration"
            trackBy="id"
            label="name"
          />
        </div>
      </div>
    </template>

    <template #footer>
      <div class="w-full">
        <div
          class="seperator text-center"
          style="margin-top: 26px !important"
        ></div>
        <div class="flex mt-20 justify-center">
          <button
            :disabled="
              !name ||
              (fileError && source == 'upload_file' && !isFileUploaded) ||
              (!isValidUrl && source == 'url') ||
              (!integration && source == 'integration') ||
              isSubmitted
            "
            @click="onSubmit"
            type="button"
            class="btn btn-primary add-button mr-30"
          >
            Add
            <span
              v-if="isSubmitted"
              class="spinner-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
          <button
            @click="resetStoreData()"
            :disabled="isSubmitted"
            type="button"
            class="btn btn-secondary cancel-button"

          >
            Cancel
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>

<style scoped>
.container,
.success-container {
  width: 416px !important;
  height: 55px;
  flex-shrink: 0;
  border-radius: 4px;
  background: #f2f2f2;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.icon {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.icon svg {
  width: 21px;
  height: 24.509px;
  flex-shrink: 0;
}

.filename-text {
  color: #2d8425;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 17px; /* 106.25% */
  letter-spacing: 0.25px;
}

.add-files-text {
  color: var(--787878, #787878);
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 17px; /* 106.25% */
  letter-spacing: 0.25px;
}

.success-container svg {
  width: 17px;
  height: 17px;
  flex-shrink: 0;
}

.success-container .text {
  margin-left: 16px;
}

.remove-file-button {
  color: var(--f-46-a-6-a, #f46a6a);
  text-align: right;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: 0.25px;
  cursor: pointer;
  border: none;
  background: transparent;
  &:disabled {
    opacity: 0.4 !important;
  }
}
.ml-16 {
  margin-left: 16px !important;
}
.filename-text.ml-16 {
  /* width: 200px; */
  width: 250px !important;
  /* overflow: hidden; */
  /* white-space: break-spaces; */
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
</style>
